module.exports = __webpack_public_path__ + "img/arrow-circle.44d0e9b8.svg";